import {eReducerStatusBase} from "../../reducer-model/eReducerStatusBase";
import {IImportTuyenSinhReducer} from "../../reducer-model/thu-phi-tuyen-sinh/IImportTuyenSinhReducer";
import {IImportTuyenSinhActionTypes} from "../../action-types/thu-phi-tuyen-sinh/IImportTuyenSinhActionTypes";

const iniState: IImportTuyenSinhReducer = {
    data: [],
    status: eReducerStatusBase.is_not_initialization,
};

export const importTuyenSinhReducer = (
    state: IImportTuyenSinhReducer = iniState,
    action: IImportTuyenSinhActionTypes
): IImportTuyenSinhReducer => {
    switch (action.type) {
        case "IMPORT_TUYEN_SINH_IMPORT_BEGIN":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                data: [],
            };
        case "IMPORT_TUYEN_SINH_IMPORT_START":
            return {
                ...state,
                processId: action.payload.process_id,
                isShowProcessing: true,
                status: eReducerStatusBase.is_saving,
            };
        case "IMPORT_TUYEN_SINH_IMPORT_SUCCESS":
            return {
                ...state,
                data: action.payload,
                isShowProcessing: false,
                status: eReducerStatusBase.is_completed,
            };
        case "IMPORT_TUYEN_SINH_IMPORT_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "IMPORT_TUYEN_SINH_SAVE_START":
            return {
                ...state,
                processId: action.payload.process_id,
                isShowProcessing: true,
                status: eReducerStatusBase.is_saving,
            };
        case "IMPORT_TUYEN_SINH_SAVE_SUCCESS":
            return {
                ...state,
                data: state.data.filter((g) => g.error),
                status: eReducerStatusBase.is_saved,
            };
        case "IMPORT_TUYEN_SINH_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "IMPORT_TUYEN_SINH_CLOSE_PROCESSING_MODAL":
            return {
                ...state,
                isShowProcessing: false,
            };
        default:
            return state;
    }
};
